import React from 'react';
import classNames from 'classnames';

import css from './IconFarmShop.module.css';

export const IconFarmShop = ({ rootClassName, className }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      id="Layer_1"
      viewBox="0 0 64 64"
      enableBackground="new 0 0 64 64"
    >
      <path
        d="M5 27.26A16.92 16.92 0 0 1 15 24c9.37 0 17 7.63 17 17 0 1.38-.16 2.72-.48 4"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <circle
        cx={15}
        cy={41}
        r={13}
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <circle
        cx={15}
        cy={41}
        r={7}
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M40 45c0-7.17 5.83-13 13-13"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <circle
        cx={53}
        cy={45}
        r={9}
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <circle
        cx={53}
        cy={45}
        r={3}
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M32 43h8M13 10h23M21 25h32c2.21 0 4 1.79 4 4v7.94M38 29v1M42 29v1M46 29v1M44 19h4v6h-4zM45 15s1 1 1 4M35 10l2 15M14 10l-2 14M23 10v15"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default IconFarmShop;